"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExcludeContentTaggedWithProperty = exports.excludeContentTaggedWithPropertyDefinition = void 0;
exports.excludeContentTaggedWithPropertyDefinition = {
    view: {
        label: 'Exclude Content Tagged With',
        style: 'tag',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['discipline', 'content-category'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'exclude-content-tagged-with',
};
const isExcludeContentTaggedWithProperty = (prop) => {
    return prop.name === exports.excludeContentTaggedWithPropertyDefinition.name;
};
exports.isExcludeContentTaggedWithProperty = isExcludeContentTaggedWithProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhjbHVkZS1jb250ZW50LXRhZ2dlZC13aXRoLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZXhjbHVkZS1jb250ZW50LXRhZ2dlZC13aXRoLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMENBQTBDLEdBQUc7SUFDeEQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLDZCQUE2QjtRQUNwQyxLQUFLLEVBQUUsS0FBSztLQUNiO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxZQUFZLEVBQUUsa0JBQWtCLENBQUM7U0FDN0M7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsNkJBQTZCO0NBQ0osQ0FBQTtBQUkxQixNQUFNLGtDQUFrQyxHQUFHLENBQUMsSUFBa0IsRUFBNEMsRUFBRTtJQUNqSCxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssa0RBQTBDLENBQUMsSUFBSSxDQUFBO0FBQ3RFLENBQUMsQ0FBQTtBQUZZLFFBQUEsa0NBQWtDLHNDQUU5QyJ9